<div class="surface-ground text-sm">
    <div class="flex flex-wrap align-items-center justify-content-center h-screen relative p-5 md:p-8 text-sm">
        <p-avatar image="/assets/img/login-bg.jpg" styleClass="w-full h-full absolute left-0 top-0"></p-avatar>
        <!-- Form -->
        <div class="surface-0 text-900 relative z-1 lg:flex-order-1 p-4 md:p-5 shadow-2 md:w-30rem border-round-2xl text-center">
                <!-- Header -->
                <div class="col-12 xl:col-12 text-center">
                    <img class="block mx-auto mb-4 w-11rem md:w-13rem" width="205" [src]="(companyInfoDetail$ | async).compDetails.logo" [alt]="(companyInfoDetail$ | async).compDetails.app_type" />

                    <h4 *ngIf="(step | async) === 'step-1'" class="text-xl font-normal mb-3 mt-6">{{'Auth.forgot-password.PAGE-TITLE' | translate}}</h4>
                    <div *ngIf="(step | async) === 'step-1'">
                        <form [formGroup]="forgotPasswordForm" (ngSubmit)="validateUserInput(forgotPasswordForm)">
                            <div class="mb-4">
                                <label for="email4" class="block text-600 font-medium mb-3 line-height-3">{{'Auth.forgot-password.INSTRUCTION-TO-USER-INPUT' | translate}}</label>
                                <input
                                    id="email4"
                                    type="text"
                                    pInputText
                                    class="w-full text-sm"
                                    (focus)="errMsg = null"
                                    placeholder="{{'Auth.forgot-password.FORGOT-INPUT-PLACEHOLDER' | translate}}"
                                    formControlName="userForgotenInput"
                                    name="userForgotenInput"
                                    autocomplete="off"
                                />
                                <app-error-msg *ngIf="UserForgotenInput.touched && UserForgotenInput.invalid" [errors]="UserForgotenInput.errors" [fieldLabel]="'Auth.forgot-password.PAGE-TITLE' | translate"> </app-error-msg>
                            </div>
                            <span class="text-danger">{{errMsg}}</span>
                            <button pButton pRipple type="submit" [loading]="isFormSubmitting" [disabled]="!forgotPasswordForm.valid" [label]="'Auth.forgot-password.SEND-ME-NEW-PASS' | translate" class="w-full text-sm"></button>

                            <div class="text-sm mt-3">Forget it, <span class="text-primary cursor-pointer" (click)="backtoLogin()">send me back</span> to the sign in screen.</div>
                        </form>
                    </div>
                    <div *ngIf="(step | async) === 'step-2'">
                        <form [formGroup]="newPasswordForm" (ngSubmit)="validateNewPassword(newPasswordForm)">
                            <div class="mb-4">
                                <label for="otp6" class="block text-900 font-medium mb-2 text-base">{{'Auth.forgot-password.OTP' | translate}}</label>
                                <input
                                    id="otp6"
                                    type="text"
                                    pInputText
                                    class="w-full"
                                    (focus)="errMsg = null"
                                    placeholder="{{'Auth.forgot-password.ENTER-VALID-OTP' | translate}}"
                                    formControlName="otpcode"
                                    name="otpcode"
                                    autocomplete="off"
                                    maxlength="6"
                                />
                                <app-error-msg *ngIf="Otpcode.touched && Otpcode.invalid" [errors]="Otpcode.errors" [fieldLabel]="'Auth.forgot-password.OTP' | translate"> </app-error-msg>
                            </div>
                            <div class="mb-4">
                                <label for="newpasswordInput4" class="block text-900 font-medium mb-2 text-base">{{'Auth.forgot-password.NEW-PASSWORD' | translate}}</label>
                                <input
                                    id="newpasswordInput4"
                                    type="password"
                                    pInputText
                                    class="w-full"
                                    (focus)="errMsg = null"
                                    placeholder="{{'Auth.forgot-password.NEW-PASSWORD' | translate}}"
                                    formControlName="newpasswordInput"
                                    name="newpasswordInput"
                                    autocomplete="off"
                                />
                                <app-error-msg *ngIf="NewpasswordInput.touched && NewpasswordInput.invalid" [errors]="NewpasswordInput.errors" [fieldLabel]="'Auth.forgot-password.NEW-PASSWORD' | translate"> </app-error-msg>
                            </div>
                            <div class="mb-4">
                                <label for="newpasswordMatchInput4" class="block text-900 font-medium mb-2 text-base">{{'Auth.forgot-password.CONFIRM-PASSWORD' | translate}}</label>
                                <input
                                    id="newpasswordMatchInput4"
                                    type="password"
                                    pInputText
                                    class="w-full"
                                    (focus)="errMsg = null"
                                    placeholder="{{'Auth.forgot-password.CONFIRM-YOUR-PASSWORD' | translate}}"
                                    formControlName="newpasswordMatchInput"
                                    name="newpasswordMatchInput"
                                    autocomplete="off"
                                />
                                <app-error-msg *ngIf="NewpasswordMatchInput.touched && NewpasswordMatchInput.invalid" [errors]="NewpasswordMatchInput.errors" [fieldLabel]="'Auth.forgot-password.CONFIRM-PASSWORD' | translate">
                                </app-error-msg>
                            </div>
                            <span class="text-danger">{{errMsg}}</span>
                            <button pButton pRipple type="submit" [loading]="isFormSubmitting" [disabled]="!newPasswordForm.valid" [label]="'Auth.forgot-password.SAVE' | translate" class="w-full font-medium"></button>
                        </form>
                    </div>
                    <div class="xl:col-10 col-12" *ngIf="(step | async) === 'step-3'">
                        <h4 class="text-xl font-normal mb-3 mt-4 md:mt-8">{{'Auth.forgot-password.PASSWORD-CHANGED-SUCCESSFULLY' | translate}}</h4>
                        <button pButton pRipple label="Back to sign-in" class="w-full font-medium" (click)="backtoLogin()"></button>
                    </div>
                </div>
    
                <!-- Need Help -->
                <div class="text-center">
                    <h6 class="text-600 text-sm font-normal mb-2">{{'Auth.login.NEED_HELP' | translate}}</h6>
                    <button pButton pRipple icon="fa fa-cog" [label]="'common.BUTTONS.BTN_CONTACT_SUPPORT' | translate" (click)="showSupportPopup = true" class="p-button-outlined p-button-secondary border-round-3xl text-sm text-700"></button>
                </div>
        </div>
        <div class="text-center lg:text-left text-white flex flex-column justify-content-center lg:mr-8 relative z-1 mt-4 lg:mt-0">
            <h1 class="md:text-4xl xl:text-6xl mb-3 pb-2">Refer a business, get upto <br class="hidden xl:block"> $10,000. It's that easy!</h1>
            <h2 class="mb-0 md:text-xl xl:text-2xl font-light">For every gym that joins UFP via a referral link, <br> you will get $10,000 Amazon Gift Card.</h2>
        </div>
    </div>
</div>


